import z from "zod";
import {
  AllServiceSlugsSchema,
  EnrollmentSchema,
  EnrollmentServiceSchema,
  EnterpriseMemberSchema,
  FlatEnrollmentSchema,
  GetEnrollmentResponseBodySchema,
  GetEnrollmentResponseSchema,
  SeatServiceSchema,
  ServiceSchema,
  UncompEnrollmentResponseBodySchema,
  UncompEnrollmentResponseSchema,
  UncompServiceSchema,
  UpdateEnrollmentResponseSchema,
  UpgradePreviewResponseSchema,
} from "../schemas";

export type Enrollment = z.infer<typeof EnrollmentSchema>;
export type GetEnrollmentResponse = z.infer<typeof GetEnrollmentResponseSchema>;
export type Service = z.infer<typeof ServiceSchema>;
export type GetEnrollmentResponseBody = z.infer<typeof GetEnrollmentResponseBodySchema>;
export type UpdateEnrollmentResponse = z.infer<typeof UpdateEnrollmentResponseSchema>;
export type FlatEnrollment = z.infer<typeof FlatEnrollmentSchema>;
export type EnterpriseMember = z.infer<typeof EnterpriseMemberSchema>;
export type EnrollmentService = z.infer<typeof EnrollmentServiceSchema>;
export type UpgradePreviewResponse = z.infer<typeof UpgradePreviewResponseSchema>;
export type SeatService = z.infer<typeof SeatServiceSchema>;
export type AllServiceSlugs = z.infer<typeof AllServiceSlugsSchema>;
export type UncompServiceT = z.infer<typeof UncompServiceSchema>;
export type UncompEnrollmentResponseT = z.infer<typeof UncompEnrollmentResponseSchema>;
export type UncompEnrollmentResponseBodyT = z.infer<typeof UncompEnrollmentResponseBodySchema>;

export enum PaymentStatuses {
  ACTIVE = "active",
  CANCELED = "canceled",
  CANCELING = "canceling",
  SEATED = "seated",
  PAST_DUE = "past_due",
}
